import React from 'react';
import cn from 'classnames';
import ImageRenderer from '@app/components/media-renderer/image-renderer';
import { featureDto } from '@app/models/dtos';

function FeatureCard({ feature }: { feature: featureDto }) {
    return (
        <div className={cn('sticky top-0 flex  h-full w-full items-center justify-center rounded-t-[72px] md:min-h-screen', feature.step % 2 === 0 ? 'bg-pink-bg' : 'bg-blue-bg')}>
            <div className="container flex w-full flex-wrap justify-center gap-[30px] py-[60px] md:flex-nowrap  md:justify-start  md:py-[120px] lg:gap-[118px]">
                <div className="aspect-square h-full max-h-[250px] w-full max-w-[250px] md:max-h-[400px] md:max-w-[400px] lg:max-h-[457px] lg:max-w-[608px]  ">
                    <ImageRenderer media={feature.image} isGrayScale={false} />
                </div>
                <div className="flex flex-col items-center justify-center text-center md:items-start md:text-start ">
                    <div className={'anonymize-h4 text-black-600'}>STEP {feature.step}</div>
                    <h2 className={cn('anonymize-h2 mb-4 mt-2 text-black-800')}>{feature.title}</h2>
                    <p className={cn('anonymize-p4 w-full max-w-[435px] !text-black-700')}>{feature.description}</p>
                </div>
            </div>
        </div>
    );
}

export default FeatureCard;
